import { Component, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { NavigateAction } from './navigate-action';

@Component({
  selector: 'navigation-controls',
  templateUrl: './navigation-controls.component.html',
  styleUrls: ['./navigation-controls.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavigationControlsComponent {

  @Output()
  public navigationChange = new EventEmitter<any>();

  onReloadClicked() {
    this.navigationChange.emit(NavigateAction.RELOAD);
  }

  onBackClicked() {
    this.navigationChange.emit(NavigateAction.BACK);
  }

  onForwardClicked() {
    this.navigationChange.emit(NavigateAction.FORWARD);
  }
}
